module.exports = __webpack_public_path__ + "img/combat-robot-damage.7b3c28c4.png";